import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const adp = defineConnector({
  identifier: "adp",
  name: "ADP",
  tagLine: "Payroll and HR management",
  keywords:
    "automatic data processing payroll hr hris workforce now workers benefits",
  logo,
  protocol: "http",
  tags: ["productivity", "it"],
  defaultUrlPattern: () => "https://[^/]*\\.adp\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create API credentials in ADP",
      items: [
        {
          kind: "markdown",
          content: `1. In the ADP developer portal, register your application
2. Note the **Client ID** and **Client Secret**
3. You’ll also need your **SSL certificate** and **key** for mutual TLS`,
        },
      ],
    },
    {
      title: "Enter your ADP details",
      items: [
        {
          kind: "url",
          label: "ADP domain",
          placeholder: "https://api.adp.com",
          required: true,
          target: { kind: "configuration", field: "adpDomain" },
          helperText:
            "Your ADP API base URL (e.g., https://api.adp.com for production, https://iat-api.adp.com for IAT).",
        },
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: () => "https://accounts.adp.com/auth/oauth/v2/token",
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_basic",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: ({ adpDomain }) => `${adpDomain}/hr/v2/workers?$top=1`,
  },
});
